import React, { useState, useContext, forwardRef, useEffect } from "react";
import { AuthContext } from "./index";

// Dùng forwardRef để truyền ref từ bên ngoài vào
const CameraInput = forwardRef((props, ref) => {
  const { isMobile, imageKeys, ActionList, dataCheckupload } = useContext(AuthContext);
  const [error, setError] = useState("");
  const [isMobileOrTablet, setIsMobileOrTablet] = useState(false);

  useEffect(() => {
    const ua = navigator.userAgent || window.opera;
    const isMobileOrTablet =
      /android|iphone|ipad/i.test(ua.toLowerCase());
    if (!isMobileOrTablet && !dataCheckupload?.config?.allowUpload) {
      setIsMobileOrTablet(false);
      setError("Thiết bị của bạn không hỗ trợ chụp ảnh.");
    } else {
      setIsMobileOrTablet(true);
      setError("");
    }
  }, []);

  const compressImage = (file, q = 0.8) => new Promise(res => {
    const i = new Image(), r = new FileReader();
    r.onload = e => i.src = e.target.result;
    i.onload = () => {
      const c = document.createElement("canvas"), x = c.getContext("2d"),
        s = Math.min(1, 1920 / i.width);
      c.width = i.width * s; c.height = i.height * s;
      x.drawImage(i, 0, 0, c.width, c.height);
      c.toBlob(b => res(new File([b], file.name, { type: "image/jpeg", lastModified: file.lastModified })), "image/jpeg", q);
    };
    r.readAsDataURL(file);
  });

  // Mở input camera sau
  const openCamera = async () => {
    setError("");
    // Nếu không cho phép upload ảnh thì check xem có camera khong để mở
    if (!dataCheckupload?.config?.allowUpload && !isMobileOrTablet) {
      setError("Thiết bị của bạn không hỗ trợ chụp ảnh.");
      return;
    }
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";
    // Check để auto mở camera sau
    if (!dataCheckupload?.config?.allowUpload && isMobileOrTablet) {
      input.capture = "environment";
    }
    input.style.display = "none";
    input.multiple = props?.multiplePhotos || false;
    input.onchange = async (e) => {
      const files = Array.from(e.target.files);
      // const newImages = files.map((file) => compressImage(file));
      const newImages = await Promise.all(files.map(f => compressImage(f, 0.6)));
      ActionList('edit', props.idxEdit, { ...imageKeys[props.idxEdit], urlLocal: [...newImages, ...imageKeys[props.idxEdit]?.urlLocal] })
    };
    document.body.appendChild(input);
    input.click();
    document.body.removeChild(input);
  };

  return (
    <div style={{ textAlign: "center" }}>
      <button ref={ref} onClick={openCamera} style={{ display: 'none' }}>
        📸 Mở Camera Sau
      </button>
      {error && <p style={{ color: "red" }}>{error}</p>}
    </div>
  );
});

export default CameraInput;